import PropTypes from "prop-types"
import React from "react"
import Grid from "semantic-ui-react/dist/es/collections/Grid/Grid"
import Header from "semantic-ui-react/dist/es/elements/Header/Header"
import Label from "semantic-ui-react/dist/es/elements/Label/Label"

const WorksheetFooter = ({ header, children, error }) => (
  <Grid.Row className="WorksheetFooter">
    <Grid.Column>
      <Grid
        className="white WorksheetFooter__Grid"
        stackable
        reversed="mobile vertically"
        style={{ padding: "1em 2em 1em 2em" }}
      >
        <Grid.Row columns="equal">
          <Grid.Column width={6} verticalAlign="middle" textAlign="left">
            <Header
              as="h5"
              color="grey"
              className="light italic"
              style={{ paddingTop: "0.25em" }}
            >
              {header}
            </Header>
          </Grid.Column>
          <Grid.Column verticalAlign="middle" textAlign="right">
            {!!error ? (
              <Label
                color="red"
                size="large"
                className="Worksheet__Error__Label"
              >
                {error}
              </Label>
            ) : (
              ""
            )}
            {children}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Grid.Column>
  </Grid.Row>
)

WorksheetFooter.propTypes = {
  header: PropTypes.node,
  error: PropTypes.node
}

export default WorksheetFooter
